import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../data.requirements";
export class resubscribePlanUseCase {
    constructor(data) {
        this.data = data;
    }
    run(uid, sid) {
        return this.data.resubscribePlan(uid, sid);
    }
}
resubscribePlanUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function resubscribePlanUseCase_Factory() { return new resubscribePlanUseCase(i0.ɵɵinject(i1.DataRequirementsInjectionToken)); }, token: resubscribePlanUseCase, providedIn: "root" });
